import React, { useState, useEffect } from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Assets/style/style.css";
import SessionExpiredModal from "./Components/SessionExpiredModal"; // Import session expired modal
import { registerSessionExpiredModal, handleLogoutRedirect } from "./Utils/sessionExpiredManager";
import { handleUrlAuthentication } from "./Utils/urlAuthHandler"; // Import URL authentication handler
import { BrowserRouter, useNavigate } from "react-router-dom"; // Keep BrowserRouter only here

// Wrapper component to handle URL authentication with navigation
function AppContent() {
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check for URL-based authentication first
    const isAuthenticatedFromUrl = handleUrlAuthentication();
    
    if (isAuthenticatedFromUrl) {
      console.log("Authenticated via URL parameters");
      // Redirect to home page after successful URL authentication
      navigate("/task-dashboard");
    }

    // Register session expired modal
    registerSessionExpiredModal(() => {
      setShowSessionExpired(true);
    });
  }, [navigate]);

  const handleCloseSessionExpired = () => {
    setShowSessionExpired(false);
    handleLogoutRedirect();
  };

  return (
    <>
      <FullRouter />
      <SessionExpiredModal 
        open={showSessionExpired} 
        onClose={handleCloseSessionExpired} 
      />
    </>
  );
}

function App() {

  return (
    <div>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
